////////////////////////////////////////////////////
//                                                //
//  ENDPOINT -> /interesses/?loja=                //
//                                                //
//  PÁGINA EXCLUSIVA PARA FRANQUEADOS PARA        //
//  VISUALIZAR OS CARRINHOS DOS CLIENTES.         //
//                                                //
//  RECEBE COMO PARÂMETRO NA URL O ID             //
//  DA LOJA QUE ESTÁ VENDENDO OS PRODUTOS.        //
//                                                //
////////////////////////////////////////////////////  



import React, {useState} from "react"

import ContinuarComprando from  '../components/continuar_comprando';
import PrecoPictureFranqueado from  '../components/preco_picture_franqueado';

import api from "../services/api";


function Interesses() {

  // ESTADOS DEFINIDOS
    // 'nomes' = LISTA DE NOMES DOS USUÁRIOS COM INTERESSES NA LOJA
    // 'favs' = LISTA DE PRODUTOS FAVORITADOS -> IMPLEMENTADO, PORÉM O ÍCONE DE FAVORITAR FOI RETIRADO DA TELA A PEDIDO DO DEPARTAMENTO DE MARKETING
    // 'carrinho' = LISTA DOS PRODUTOS NO CARRINHO   

  let [nomes, setNomes] = useState([])
  let [favs, setFavs] = useState([])
  let [carrinho, setCarrinho] = useState([])
 

  window.onload = async function() {
    // FUNÇÃO CHAMADA NO CARREGAMENTO DESTA PÁGINA ('interesses/loja=')

    var params = window.location.search 
    var urlparams = new URLSearchParams(params)
    var loja = urlparams.get('loja')
    
    if(loja != sessionStorage['loja']){  // VERIFICA SE A LOJA DA URL É A MESMA LOJA DA SESSION
      window.location.href = '/interesses/?loja='+ sessionStorage['loja']  // CASO NÃO SEJA, REDIRECIONA PARA A PÁGINA DA LOJA DA SESSION
    }
    
    var login = await api.post('verificar_login',{  // VERIFICA NO DB SE A LOJA CORRESPONDE AO TOKEN E TAMBÉM BUSCA O VALOR DO ESTOQUE DE SEGURANÇA DA LOJA
      "id_loja": sessionStorage['loja'],
      "login": sessionStorage['login']
    }).then((response) => {
      return response
    })    
    // login['data'] RETORNA UM DICIONÁRIO COM AS CHAVES
      // 'login' ->  BOOLEANO QUE DEFINE SE O USUÁRIO PODE PERMANECER NA PÁGINA

      // 'id' -> STRING COM O ID DO USUÁRIO CORRETO
        // ISSO OCORRE CASO 'login' SEJA FALSO PORQUE OS TOKENS DE LOGIN SAO INCOMPATÍVEIS
        // CASO 'login' SEJA FALSO E O TERMO 'id' NÃO ESTEJA NO DICIONÁRIO, O USUÁRIO NÃO FOI ENCONTRADO NO DB
      
      // 'estoque_seguranca' -> INT COM O VALOR DO ESTOQUE DE SEGURANÇA QUE ESTÁ SALVO NO DB
        // ESSE VALOR APARECE NO DICIONÁRIO APENAS SE LOGIN FOR TRUE    
    
    if(!login['data']['login']){  // SE NÃO CORRESPONDER
      sessionStorage['loja'] = login['data']['id']  // TROCA A LOJA DA SESSION
      window.location.href = '/interesses/?loja='+ login['data']['id']  // E REDIRECIONA PARA A PÁGINA DA LOJA CORRETA
    }

    search_clientes()  // BUSCA OS CLIENTES COM INTERESSES NA LOJA
  }

  async function search_clientes(){  // FUNÇÃO PARA BUSCAR OS CLIENTES COM INTERESSES NA LOJA
    var clientes = await api.post('buscar_clientes_loja',{  // BUSCA NO DB OS CLIENTES COM INTERESSES NA LOJA
      "id_loja": sessionStorage['loja'],
      "login": sessionStorage['login']
    }).then((response) => {
      return response
    })   
    // clientes['data'] RETORNA UMA COM AS CHAVES
      // 'data' ->  LISTA COM OS CLIENTES
        // CADA ITEM DA LISTA É UMA LISTA COM DUAS POSIÇÕES
          // 1a POSIÇÃO -> STRING COM O NOME DO CLIENTE
          // 2a POSIÇÃO -> STRING COM ID DO CLIENTE

    setNomes(clientes['data']['data'])  // DEFINE O ESTADO DOS NOMES COM AS INFORMAÇÕES ENCONTRADAS
  }

  async function search_itens(){  // FUNÇÃO CHAMADA AO ALTERAR O SELECT 'cliente' DA PÁGINA
    setFavs([])  // REMOVE AS INFORMAÇÕES DO CLIENTE SELECIONADO ANTERIORMENTE
    setCarrinho([])
    var id_cliente = document.getElementById('cliente').value

    if(id_cliente == '---------'){  // CASO O VALOR DO DROPDOWN NÃO SEJA UM CLIENTE
      document.getElementById('div_interesses').classList.add('d-none')  // APAGA O CARD COM AS INFORMAÇÕES DOS CLIENTES
    }
    else{  // CASO O VALOR DO DROPDOWN SEJA UM CLIENTE
      document.getElementById('div_interesses').classList.remove('d-none')  // APARECE O CARD COM AS INFORMAÇÕES DO CLIENTE SELECIONADO
    }

    var favs_novo = []
    var carrinho_novo = []

      var resp = await api.post('buscar_favs',{  // BUSCA NO DB OS INTERESSES DO CLIENTE SELECIONADO
        "loja": sessionStorage['loja'],
        "usuario": id_cliente,
      }).then((response) => {
        return response
      })
      // resp['data'] RETORNA UMA COM AS CHAVES
        // 'fav' -> VAZIO POIS NADA ESTÁ FAVORITADO A PEDIDO DO DEPARTAMENTO DE MARKETING
      
        // 'car' LISTA COM OS PRODUTOS NO CARRINHO DO CLIENTE SELECIONADO
          // CADA ITEM DA LISTA É UM DICIONARIO COM AS CHAVES
            // 'dsc' -> STRING COM DESCRIÇÃO DO PRODUTO
            // 'id' -> STRING COM ID DO PRODUTO     
            // 'img' -> STRING COM URL DA IMAGEM DO PRODUTO     

      favs_novo = favs_novo.concat(resp.data.fav)  // JUNTA COM AS INFORMAÇÕES ANTERIORES (VAZIAS)
      carrinho_novo = carrinho_novo.concat(resp.data.car)

      setFavs(favs_novo)  // DEFINE OS ESTADOS DE FAVORITOS E CARRINHO
      setCarrinho(carrinho_novo)
      
  }

  if(!sessionStorage['login']){  // CASO O USUARIO NAO ESTEJA LOGADO
    window.location.href = '/?id='+ sessionStorage['loja']     
  }  
  else{
    if(!sessionStorage['login'].includes('/')){  // OU ESTEJA LOGADO COMO USUÁRIO E NÃO FRANQUEADO
      window.location.href = '/?id='+ sessionStorage['loja']  // REDIRECIONA PARA A PÁGINA HOME
    }
    else{  // CASO ESTEJA LOGADO COMO FRANQUEADO RENDERIZA A PÁGINA

      // OS COMPONENTES DA PÁGINA SÃO (NA ORDEM QUE APARECEM):
        // 'ContinuarComprando' -> VERSÃO DO HEADER QUE NÃO APARECE A BARRA DE PESQUISA E SIM BOTÃO DE VOLTAR PARA A PÁGINA HOME      
        // 'PrecoPictureFranqueado' -> CARD COM DESCRIÇÃO E FOTO DE CADA PRODUTO
      return (
        <div>
          <div>
            <ContinuarComprando />

          </div>
      
      
          <div id="todos_os_produtos" class="card-login pb-0">
            <div class='mb-5'>
              <p class="verde montserrat fonte-x-large">
      
              Escolha o Cliente:
              </p>
              <select id='cliente' class='w-100 select' onChange={search_itens}>
                <option>---------</option>
                {nomes.map((block) => (
                  <option value = {block[1]}>{block[0]}</option>
                  ))}            
              </select>
            </div>
                
            {/* <div class="border-bottom my-5">
              Favoritos:
              <div class="d-flex flex-wrap justify-content-between px-0 pt-0 start-page custom-container-catalogo align-items-end">
              {favs.map((block) => (
                <PrecoPictureFranqueado id_prod={block.id} img={block.img} dsc={block.dsc} />
              ))}            
              </div>
            </div> */}
            <div class="mt-4 px-1 d-none" id='div_interesses'>
              Produtos no Carrinho:
              <div class=" mt-3 d-flex flex-wrap justify-content-between px-0 pt-0 start-page align-items-end">
              {carrinho.map((block) => (
                <PrecoPictureFranqueado id_prod={block.id} img={block.img} dsc={block.dsc} />
              ))}  
              </div>
            </div>        
              
              
          </div>
        </div>    
      )
    }
  }
}


export default Interesses;